const testimonialsModuleElements = document.querySelectorAll('[data-slider="testimonials-module"]');

const testimonialsModuleOptions = {
  slidesPerView: 1,
  spaceBetween: 20,
  autoHeight: true,
  watchOverflow: true,
  effect: 'fade',
  navigation: {
    nextEl: '.swiper-button-prev',
    prevEl: '.swiper-button-next',
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  fadeEffect: {
    crossFade: true,
  },
};

const testimonialsThreeColOptions = {
  slidesPerView: 'auto',
  spaceBetween: 15,
  autoHeight: false,
  watchOverflow: true,
  navigation: {
    nextEl: '.swiper-button-prev',
    prevEl: '.swiper-button-next',
  },
  breakpoints: {
    768: {
      slidesPerView: 2,
    },
    1023: {
      slidesPerView: 3,
    },
  },
};

testimonialsModuleElements.forEach((el) => {
  const parentElem = el.closest('.testimonials-module');
  const arrowRight = parentElem.querySelector('.arrow-right');
  const arrowLeft = parentElem.querySelector('.arrow-left');
  const paginationElement = parentElem.querySelector('.slider-pagination');

  if (el.classList.contains('testimonials-module__init--three-col')) {
    testimonialsThreeColOptions.navigation.nextEl = arrowRight;
    testimonialsThreeColOptions.navigation.prevEl = arrowLeft;

    // eslint-disable-next-line no-new
    new Swiper(el, testimonialsThreeColOptions);
  } else {
    testimonialsModuleOptions.navigation.nextEl = arrowRight;
    testimonialsModuleOptions.navigation.prevEl = arrowLeft;
    testimonialsModuleOptions.pagination.el = paginationElement;

    // eslint-disable-next-line no-new
    new Swiper(el, testimonialsModuleOptions);
  }
});

const loadMoreTestimonials = document.querySelector('.testimonials-module__load-more');

const loadMoraTestimonials = () => {
  attachEvent('.testimonials-module__load-more', 'click', (ev) => {
    const parentElem = ev.target.closest('.container');
    const testimonialsInner = parentElem ? parentElem.querySelector('.testimonials-module__init--three-col .swiper-wrapper') : null;
    const ajaxData = new FormData();
    const page = testimonialsInner.getAttribute('data-page');
    ajaxData.append('action', 'loadMoreItems');
    ajaxData.append('page', page);
    ajaxData.append('key', testimonialsInner.getAttribute('data-key'));
    ajaxData.append('id', testimonialsInner.getAttribute('data-id'));
    ajaxData.append('k', testimonialsInner.getAttribute('data-k'));
    axios
      .post(localData.siteURL, ajaxData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => {
        if (response.status === 200) {
          if (response.data.data.showMore) {
            // eslint-disable-next-line no-param-reassign
            ev.target.closest('.testimonials-module__footer').style.display = 'none';
          }
          testimonialsInner.innerHTML += response.data.data.posts;
          testimonialsInner.dataset.page = parseInt(page, 10) + 1;
        }
      })
      .catch((err) => {
        console.error(err);
      });
  });
};

if (loadMoreTestimonials) {
  loadMoraTestimonials();
}
